<kl-field-validation-wrapper-yup :field="tagsField" #default="{hasErrors}">
    <vl-multiselect
        v-bind="$attrs"
        ref="multiselect"
        v-model="tags"
        autocomplete="off"
        :options="tagSuggestions"
        :disabled="modDisabled"
        mode="tags"
        :create-option="true"
        :searchable="true"

        placeholder="Tags toevoegen"
        select-label="Selecteer tag"
        tag-placeholder="Voeg nieuwe tag toe"
        noResultsText="Geen tags gevonden..."
        noOptionsText="Geen tags beschikbaar!"

        @select="onSelect"
        :on-create="handleTagCreate"
    >
    </vl-multiselect>
</kl-field-validation-wrapper-yup>
